import {
  SET_TILES_PER_ROW
} from '../actionTypes';

import tileRowSize from '../../../lib/utils/tileRowSize.js';

const width = document.documentElement.clientWidth;
const initialState = tileRowSize(width);

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_TILES_PER_ROW: {
      return action.payload;
    }
    default:
      return state;
  }
}
